import { Helmet } from "react-helmet";
import { useMediaQuery } from "react-responsive";
import projectsBg from "../assets/projects/bgMain1.png";
import careerBg2 from "../assets/career/bgSecondary1.png";
import careerBg5 from "../assets/career/bgMain3Gen.png";
import luis from "../assets/team/luis.png";
import cristian from "../assets/team/cristian.png";

import careerBg6 from "../assets/career/bgSecondary3.png";
import {
  advantages,
  focusItems,
  participantItems,
  programStructure,
  ventureStartups,
} from "./data";
import StudyProjectCard from "../common/studyProjectCard";
import bgHomeSecondary3XL from "../assets/home/bgHomeSecondary3XL.png";
import bgHomeSecondary3Tablet from "../assets/home/bgHomeSecondary3Tablet.png";
import bgHomeMain3XL from "../assets/home/bgHomeMain3XL.png";
import bgHomeMain4XL from "../assets/home/bgHomeMain4XL.png";
import BookCallWith from "../common/bookCallWith";
import BookCallDontFind from "../common/bookCallDontFind";

function Venture() {
  const isMobile = useMediaQuery({ query: "(max-width: 833px)" });
  const isXLScreen = useMediaQuery({ query: "(min-width: 1440px)" });

  return (
    <div>
      <Helmet>
        <title>Venture Studio Program | Protofire</title>
        <meta
          name="description"
          content="Join Protofire's Venture Studio Program to co-build Web3 startups with industry experts. Get funding, support, and access to top-tier infrastructure to launch your blockchain business."
        />
        <meta
          name="keywords"
          content="Web3 startup, venture studio, Protofire, blockchain program, startup funding, Web3 development, decentralized apps, crypto startups, Web3 incubation, blockchain venture studio"
        />
      </Helmet>
      <div
        className="bg-no-repeat bg-auto"
        style={{ backgroundImage: `url(${projectsBg})` }}
      >
        <div
          className="bg-no-repeat bg-bottom bg-auto xl:bg-[length:100%_667px]"
          style={{ backgroundImage: `url(${careerBg2})` }}
        >
          <div className="max-w-[1120px] mx-auto pt-[80px]">
            <section className="mx-4 md:mx-6 xl:mx-0">
              <div className="md:max-w-[544px] pt-[100px] md:pt-[120px] text-white100">
                <h1
                  className="text-[32px] leading-[40px] md:text-5xl md:leading-[56px] xl:text-[64px] xl:leading-[72px]"
                  style={{ fontFamily: "Onest-SemiBold" }}
                >
                  Want to build a Web3 startup?
                </h1>
                <p
                  className="mt-4 mb-0 text-base md:text-lg"
                  style={{ fontFamily: "Onest-ExtraLight" }}
                >
                  Are you an ambitious entrepreneur ready to drive the next
                  evolution of Web3? Do you possess a compelling business
                  proposition that could benefit from structured investment,
                  strategic mentorship, and operational acceleration?
                </p>
                <p className="mt-4 mb-0 text-base md:text-lg">
                  Join Protofire’s Venture Studio Program to cultivate, refine,
                  and scale your enterprise into a market-defining Web3 venture.
                </p>
              </div>
            </section>
            <section className="pt-[120px] md:pt-[168px] mx-4 md:mx-6 xl:mx-0 xl:max-w-[832px] pb-[120px]">
              <h2
                className="text-white100 text-[32px] leading-[40px] md:text-[40px] md:leading-[48px] xl:text-[48px] xl:leading-[56px]"
                style={{ fontFamily: "Onest-SemiBold" }}
              >
                Why Engage with Protofire’s Venture Studio?
              </h2>
              <p className="my-0 text-base text-white55 mt-4">
                Protofire is a leading venture studio focused on incubating and
                spinning off high-potential blockchain projects. We partner or
                build with top blockchain ecosystems, including Aave, Balancer,
                Maker, Optimism, and Ethereum Foundation, to support early-stage
                ventures with funding, strategic guidance, and technical
                expertise.
              </p>
            </section>
          </div>
        </div>
        <div className="max-w-[1120px] mx-auto">
          <section className="mx-4 md:mx-6 xl:mx-0">
            <h2
              className="text-white100 text-[32px] leading-[40px] md:text-[40px] md:leading-[48px] xl:text-[48px] xl:leading-[56px] xl:max-w-[832px]"
              style={{ fontFamily: "Onest-SemiBold" }}
            >
              Our Focus
            </h2>
            <p className="my-0 text-base text-white55 mt-4 xl:max-w-[832px]">
              We specialize in identifying, validating, and scaling Web3
              solutions with the potential to become independent,
              revenue-generating businesses. Our expertise spans:
            </p>
            <div className="mt-[56px] grid grid-cols-2 md:grid-cols-4 xl:grid-cols-5 gap-8">
              {focusItems.map(
                (item: { id: string; text: string }, index: number) => (
                  <div
                    className="w-[204px] h-[204px] text-base text-white100 rounded-full flex items-center justify-center px-6"
                    key={item.id}
                    style={{
                      background:
                        index % 2 === 1
                          ? "linear-gradient(0deg, rgba(241, 248, 255, 0.16) 0%, rgba(145, 149, 153, 0) 100%)"
                          : "linear-gradient(180deg, rgba(241, 248, 255, 0.16) 0%, rgba(145, 149, 153, 0) 100%)",
                    }}
                  >
                    <span className="text-center">{item.text}</span>
                  </div>
                )
              )}
            </div>
          </section>
          <section className="mt-[56px] mx-4 md:mx-6 xl:mx-0">
            <p className="my-0 text-base text-white55 xl:max-w-[832px]">
              Through our Venture Studio model, we actively invest in and spin
              off Web3 startups, transforming innovative ideas into
              market-leading companies.
            </p>
            <div className="flex flex-col md:grid grid-cols-6 gap-8 mt-[56px] ">
              {ventureStartups.map((item) => (
                <StudyProjectCard
                  imgSrc={item.imgSrc}
                  title={item.title}
                  tagList={item.tagList}
                  text={item.text}
                  link={item.link}
                  className="col-span-6 md:col-span-3"
                  isOuterLink
                  key={item.id}
                />
              ))}
            </div>
          </section>
        </div>

        <div className="max-w-[1120px] mx-auto pt-[120px] md:pt-[150px]">
          <section className="mx-4 md:mx-6 xl:mx-0 xl:max-w-[832px]">
            <h2
              className="text-white100 text-[32px] leading-[40px] md:text-[40px] md:leading-[48px] xl:text-[48px] xl:leading-[56px] xl:max-w-[832px]"
              style={{ fontFamily: "Onest-SemiBold" }}
            >
              Core Advantages of Participation
            </h2>
            <p className="my-0 text-base text-white55 mt-4 mb-[56px]">
              Protofire has been working in the Web3 space since 2016 and has an
              extensive network among the top 70+ blockchain protocols and
              ecosystems. This network provides unique access to strategic
              partnerships, industry-leading expertise, and deep market
              insights.
            </p>
            {advantages.map((item, index) => (
              <div
                className={`flex flex-col md:flex-row gap-6 ${
                  index !== advantages.length - 1
                    ? "border-b border-dashed border-white15 pb-10"
                    : ""
                } ${index > 0 ? "pt-10" : ""}`}
                key={item.title}
              >
                <div className="text-lg text-white100 flex-[3]">
                  {item.title}
                </div>
                <div className="flex-[5] flex flex-col gap-8 text-white55 text-base">
                  {item.description}
                </div>
              </div>
            ))}
          </section>
        </div>

        <div
          className="bg-no-repeat bg-top"
          style={{
            backgroundImage: isMobile
              ? "none"
              : `url(${
                  isXLScreen ? bgHomeSecondary3XL : bgHomeSecondary3Tablet
                })`,
          }}
        >
          <div
            className="bg-no-repeat bg-left-top"
            style={{
              backgroundImage: `url(${bgHomeMain3XL})`,
            }}
          >
            <div
              className="bg-no-repeat bg-right-top"
              style={{
                backgroundImage: `url(${bgHomeMain4XL})`,
              }}
            >
              <div className="max-w-[1120px] mx-auto">
                <section className="pt-[70px] mt-[30px] mx-4 md:mx-6 xl:mx-0">
                  <div className="max-w-[832px]">
                    <h2
                      className="text-white100 text-[32px] leading-[40px] md:text-[40px] md:leading-[48px] xl:text-[48px] xl:leading-[56px]"
                      style={{ fontFamily: "Onest-SemiBold" }}
                    >
                      Your Role as a Venture Studio Entrepreneur
                    </h2>
                    <p className="mt-4 mb-0 text-white55 text-base md:text-lg">
                      As a Venture Studio participant, you will benefit from
                      Protofire’s extensive connections with leading blockchain
                      protocols, ensuring access to high-value partnerships and
                      collaboration opportunities.
                    </p>
                    <p className="mt-[56px] mb-0 text-white55 text-base md:text-lg">
                      As a Venture Studio participant, you will:
                    </p>
                  </div>
                  <div
                    className="mt-[100px] grid xl:grid-cols-4 sm:grid-cols-2 gap-2 md:gap-4 xl:gap-8
                lg:text-sm md:text-sm sm:text-xs text-blue100"
                    style={{
                      fontFamily: "Onest-Light",
                    }}
                  >
                    {participantItems.map((item) => (
                      <div
                        key={item}
                        className="flex flex-col items-center justify-center p-6 xl:p-8 rounded-lg text-base text-white100 text-center"
                        style={{
                          backdropFilter: "blur(56px)",
                          background:
                            "linear-gradient(0deg, rgba(241, 248, 255, 0.03) 0%, rgba(145, 149, 153, 0) 100%)",
                        }}
                      >
                        {item}
                      </div>
                    ))}
                  </div>

                  <div className="max-w-[832px] mt-[100px]">
                    <h2
                      className="text-white100 text-[32px] leading-[40px] md:text-[40px] md:leading-[48px] xl:text-[48px] xl:leading-[56px]"
                      style={{ fontFamily: "Onest-SemiBold" }}
                    >
                      Program Structure
                    </h2>
                    <p className="mt-4 mb-[56px] text-white55 text-base md:text-lg">
                      Our structured approach ensures entrepreneurs receive the
                      necessary support at every journey stage. From ideation to
                      scaling, our program is designed to guide and empower
                      founders to build sustainable and impactful Web3 ventures.
                      The following phases outline the pathway to success:
                    </p>
                    {programStructure.map((item, index) => (
                      <div
                        className={`flex flex-col md:flex-row gap-6 ${
                          index !== programStructure.length - 1
                            ? "border-b border-dashed border-white15 pb-10"
                            : ""
                        } ${index > 0 ? "pt-10" : ""}`}
                        key={item.title}
                      >
                        <div className="text-lg text-white100 flex-[3]">
                          {item.title}
                        </div>
                        <div className="flex-[5] flex flex-col gap-8 text-white55 text-base">
                          {item.description}
                        </div>
                      </div>
                    ))}
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>

        <div
          className="bg-no-repeat bg-left-top bg-auto xl:bg-[length:auto_1000px] pt-[120px] md:pt-[150px] "
          style={{
            backgroundImage: isMobile ? "" : `url(${careerBg5})`,
          }}
        >
          <div className="max-w-[1120px] mx-auto mb-">
            <section
              className="mx-4 md:mx-6 xl:-mx-[100px] xl:px-[100px] bg-no-repeat bg-auto bg-right-top"
              style={{
                backgroundImage: isMobile ? "none" : `url(${careerBg6})`,
              }}
            >
              <h2
                className="text-white100 text-[32px] leading-[40px] md:text-[40px] md:leading-[48px] xl:text-[48px] xl:leading-[56px]  xl:max-w-[832px]"
                style={{ fontFamily: "Onest-SemiBold" }}
              >
                Shape the Future of Web3 with Protofire
              </h2>
              <p className="m-0 mt-4 text-base xl:text-lg text-white55 xl:max-w-[832px]">
                Be part of the next wave of blockchain innovation with Protofire
                Venture Studio. Apply now and take the next step in your
                entrepreneurial journey. Don’t miss this opportunity to connect
                with top-tier blockchain networks and accelerate your success.
              </p>
            </section>
            <div className="flex flex-col md:flex-row gap-8 mt-[56px]">
              <BookCallWith
                className="w-full"
                imgUrl={luis}
                name="Luis Medeiros"
                lnUrl="https://www.linkedin.com/in/lvgmedeiros/"
                calendlyCallPostfix="luis-protofire"
                text=" "
                isMobileLike
              />
              <BookCallWith
                className="w-full"
                imgUrl={cristian}
                name="Cristian Malfesi"
                lnUrl="https://www.linkedin.com/in/cristian-malfesi/"
                // calendlyCallPostfix="cristian-protofire"
                text=" "
                isMobileLike
              />
            </div>
            <div className="my-[120px]">
              <BookCallDontFind mainText="Don't find that you are looking for?" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Venture;
